export function readSchedulingSchemas(snapshot) {
  return snapshot.docs.map((schemaDoc) => {
    const data = schemaDoc.data();
    return {
      id: schemaDoc.id,
      name: data.name || "Namnlöst schema",
      visibleEmployeeIds: Array.isArray(data.visibleEmployeeIds) ? data.visibleEmployeeIds : null,
    };
  }).sort((a, b) => a.name.localeCompare(b.name, "sv"));
}

export function readSchedulingEmployees(snapshot) {
  return snapshot.docs.map((employeeDoc) => {
    const data = employeeDoc.data();
    const name = [data.firstName, data.lastName].filter(Boolean).join(" ") ||
      data.name || data.displayName || data.userName || data.email || "Användare";
    return { ...data, id: employeeDoc.id, name, email: data.email || "", workTimeId: data.workTimeId || "" };
  });
}

export function readSchedulingOwner(snapshot) {
  const data = snapshot.data();
  if (data?.role !== "super-admin") return null;
  return {
    id: snapshot.id,
    name: [data.firstName, data.lastName].filter(Boolean).join(" ") ||
      data.companyName || data.email || "Företagsägare",
    email: data.email || "",
    workTimeId: data.workTimeId || "",
  };
}

export function mergeSchedulingEmployees(employedEmployees, ownerEmployee) {
  const employees = [...employedEmployees];
  if (ownerEmployee) {
    const index = employees.findIndex((employee) =>
      employee.id === ownerEmployee.id ||
      (employee.email && ownerEmployee.email &&
        employee.email.trim().toLowerCase() === ownerEmployee.email.trim().toLowerCase())
    );
    if (index === -1) employees.push(ownerEmployee);
    else {
      // Preserve the employed ID used by saved schemas, but prefer live owner data.
      employees[index] = { ...employees[index], ...ownerEmployee, id: employees[index].id };
    }
  }
  return employees.sort((a, b) => (a.name || "").localeCompare(b.name || "", "sv"));
}

export function filterEmployeesForSchema(employees, employeeIds, search = "") {
  if (!Array.isArray(employeeIds)) return [];
  const allowedIds = new Set(employeeIds);
  const normalizedSearch = search.trim().toLowerCase();
  return employees.filter((employee) => allowedIds.has(employee.id) &&
    (employee.name || "").toLowerCase().includes(normalizedSearch));
}
